import React, { useEffect } from 'react'
import { RouteComponentProps } from 'react-router'
import { cognitoAuth } from '../../services/auth/cognito'
import configProvider from '../../config'
import { log } from '../../logger'
import { Loading } from 'atom/loader'

export const CognitoLoginPage: React.FC<RouteComponentProps> = () => {
  useEffect(() => {
    log('Initiating Cognito login')

    // Check if we have a hosted UI domain configured
    const cognitoConfig = configProvider.config.cognito

    if (cognitoConfig.domain) {
      // Use hosted UI
      cognitoAuth.signInWithHostedUI().catch((error) => {
        log('Failed to initiate Cognito hosted UI login', { error })
      })
    } else {
      // Redirect to a custom login form if no hosted UI is configured
      log('No Cognito hosted UI domain configured, redirect to custom login form')
      // You could redirect to a custom login form here
    }
  }, [])

  return <Loading size={'large'} />
}
